import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { WizardState, initialWizardState } from '../models/wizard-state.model';

@Injectable({
  providedIn: 'root'
})
export class WizardStateService {
  private state$ = new BehaviorSubject<WizardState>(initialWizardState);

  constructor() { }

  get state(): Observable<WizardState> {
    return this.state$.asObservable();
  }

  get currentState(): WizardState {
    return this.state$.getValue();
  }

  updateState(partialState: Partial<WizardState>): void {
    this.state$.next({
      ...this.currentState,
      ...partialState
    });
  }

  resetState(preserveMapInfo?: { mapId: string, mapName: string, mapIdPreset?: boolean }): void {
    if (preserveMapInfo) {
      this.state$.next({
        ...initialWizardState,
        mapId: preserveMapInfo.mapId,
        mapName: preserveMapInfo.mapName,
        mapIdPreset: preserveMapInfo.mapIdPreset ?? false
      });
    } else {
      this.state$.next(initialWizardState);
    }
  }
}
